import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";
import { IMAGES, INSURED_LABEL } from "@/data/content";

const POINTS = [
  "Professional and respectful service",
  "Clear communication",
  "Flexible appointments",
  INSURED_LABEL,
];

const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

export default function About() {
  return (
    <section id="about" className="py-16 md:py-32 bg-secondary/40" data-testid="about-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[2rem] overflow-hidden min-h-[460px] shadow-xl"
        >
          <img src={IMAGES.about} alt="Explus Cleaning LLC professional providing detailed residential cleaning" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 bg-background/95 backdrop-blur rounded-2xl p-6 shadow-lg">
            <span className="text-emerald-600 font-semibold text-sm">Explus Cleaning LLC</span>
            <p className="font-heading text-2xl text-primary mt-1">Clean spaces. Better days.</p>
          </div>
        </motion.div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">About Us</p>
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-primary">
            Cleaning you can feel confident about
          </h2>
          <p className="mt-5 text-foreground/75 text-lg leading-relaxed">
            Explus Cleaning LLC provides dependable residential and commercial cleaning
            services with close attention to detail.
          </p>
          <p className="mt-4 text-foreground/75 leading-relaxed">
            Our goal is simple: make every space look cleaner, feel fresher and give our
            clients more time to focus on what matters most.
          </p>

          <ul className="mt-7 grid sm:grid-cols-2 gap-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-3 text-primary font-medium">
                <CheckCircle size={22} weight="fill" className="text-emerald-600 shrink-0" /> {p}
              </li>
            ))}
          </ul>

          <button
            onClick={() => scrollTo("#quote")}
            className="mt-8 rounded-full bg-primary text-primary-foreground font-semibold px-8 py-4 hover:-translate-y-0.5 hover:shadow-lg transition-all"
            data-testid="about-quote-btn"
          >
            Get Your Quote
          </button>
        </div>
      </div>
    </section>
  );
}
